import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import { useIntl } from 'umi';
import { keywordsReplaceText } from './utils';
import AutoTextArea from '@op/components/AutoTextArea';
import { KeywordSearchModelType } from '../../types';
import KeywordTips from './KeywordTips';
import { NO_DATE } from '@op/constants';

// A +(B;C)+(D;F)

export default function CustomInput({
  customInput,
  setCustomInput,
  keywordSearchType,
  setKeywordSearchType,
  renderList,
  grammarTrue,
  grammarText,
  className,
}: {
  customInput: string;
  setCustomInput: React.Dispatch<React.SetStateAction<string>>;
  keywordSearchType: KeywordSearchModelType;
  setKeywordSearchType: React.Dispatch<
    React.SetStateAction<KeywordSearchModelType>
  >;
  renderList: string[][];
  grammarTrue: boolean;
  grammarText?: string;
  className?: any;
}) {
  const { formatMessage } = useIntl();

  return (
    <div className={`dbo-custom-input-content ${className}`}>
      {/* <RadioGroup
        value={keywordSearchType}
        onChange={(value: string) =>
          setKeywordSearchType(value as KeywordSearchModelType)
        }
      >
        <Radio name="extend">
          <BubbleCommon
            showIcon={false}
            tipsMap={keywordDrillUrlExtendedSearchTips}
            placement="top"
          >
            {formatMessage({ id: keywordModalTextMap.extend })}
          </BubbleCommon>
        </Radio>
        <Radio name="exact">
          <BubbleCommon
            showIcon={false}
            tipsMap={keywordDrillUrlExactSearchTips}
            placement="top"
          >
            {formatMessage({ id: keywordModalTextMap.exact })}
          </BubbleCommon>
        </Radio>
      </RadioGroup> */}
      <div className="dbo-customs-keywords-fill">
        <AutoTextArea
          size="full"
          placeholder={formatMessage({ id: 'Please enter' })}
          className="dbo-customs-keywords-fill-input"
          value={customInput}
          onChange={(value) => {
            let info = value;
            keywordsReplaceText.forEach((item) => {
              info = info.replaceAll(item.text, item.value);
            });
            setCustomInput(info);
          }}
        />
        {customInput && (
          <div
            className={`dbo-form-fill-status ${
              grammarTrue ? '--correct' : '--error'
            }`}
          >
            <SvgIcon type={`${grammarTrue ? 'zhengque' : 'erry-icontip'}`} />
            <span>{formatMessage({ id: grammarText || NO_DATE.EMPTY })}</span>
          </div>
        )}
      </div>
      {renderList.length > 0 && (
        <div className="dbo-result-box">
          <p className="dbo-result-tips">
            {formatMessage({
              id:
                keywordSearchType === 'exact'
                  ? 'Search reviews with these keyword combinations.'
                  : 'Search reviews with these keyword combinations (examples)',
            })}
          </p>
          <ul className="dbo-result-info">
            {renderList.map((item, index) => {
              const itemStr = item
                .map((it) => (it.includes('+') ? `(${it})` : it))
                .join(' + ');
              return (
                <li className="dbo-result-item" key={itemStr + index}>
                  {index + 1}. {itemStr}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <KeywordTips></KeywordTips>
    </div>
  );
}
